/**
 * Constantes de l'application
 */

// Version de l'application
// Récupérée depuis la variable globale __APP_VERSION__ définie par Vite au build
// ou depuis import.meta.env.VITE_APP_VERSION si disponible
// Valeur par défaut: '0.0.0'
export const APP_VERSION = 
  (typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 
   (typeof import.meta !== 'undefined' && import.meta.env?.VITE_APP_VERSION) || 
   '0.0.0')

